module.exports = __webpack_public_path__ + "static/equipement_loisir-b2958c272224963d9c12a7dfdd96e513.png";